import { useState, useCallback } from 'react';
import VoucherSuperpartnerCorsistaService from '../services/VoucherSuperpartnerCorsistaService/VoucherSuperpartnerCorsistaService';
import { handleError } from '../model/handleError';
import { alertService } from '../services/AlertService';

const useVoucherSuperpartnerCorsista = () => {
    const [isLoading, setIsLoading] = useState(false);

    const getVoucherStock = useCallback(async (data) => {
        setIsLoading(true);
        try {
            // Ora la chiamata è coerente: getVoucherStock chiama getVoucherStock
            return await VoucherSuperpartnerCorsistaService.getVoucherStock(data);
        } catch (error) {
            handleError(error);
            return null;
        } finally {
            setIsLoading(false);
        }
    }, []);

    const consumeVoucherForCorsista = useCallback(async (data) => {
        setIsLoading(true);
        try {
            await VoucherSuperpartnerCorsistaService.consume(data);
            alertService.success("Voucher consumato con successo!", { autoClose: true });
            return true;
        } catch (error) {
            handleError(error);
            return false;
        } finally {
            setIsLoading(false);
        }
    }, []);

    return {
        isLoading,
        getVoucherStock,
        consumeVoucherForCorsista
    };
};

export default useVoucherSuperpartnerCorsista;